import { constantTree } from "../../../core/events/ConstantTree";

export const addShuttleTransferTree = constantTree({
    AddShuttle: {
        Back: "",
        Init: "",

        SelectStop: {
            Click: ""
        },
        SelectTrip: {
            Click: ""
        },
        DeleteOffer: {
            Click: ""
        },
        Continue: {
            Click: ""
        },
        UpdateSelectedShuttles: {
            Click: ""
        }
    }
})